<div class="overlay-inner-wrapper">
  <div id="measurementWrapper">
    <header class="header-2" style="margin-left: -15px; margin-top: -15px; margin-right: -15px">
      <div class="branding">
        <span class="title">{{ 'Längswelligkeitsmessungen' | mrTranslate }} • {{ name }}</span>
      </div>
      <div class="header-actions">
        <clr-select-container
          style="
            display: flex !important;
            flex-direction: row !important;
            align-items: center !important;
            margin: 0 !important;
            padding: 0 !important;
          ">
          <!-- Das Label bekommt eine feste Textfarbe und verliert die Standard-Formularabstände -->
          <label
            style="
              color: var(--clr-header-color, white) !important;
              margin: 0 0.5rem 0 0 !important;
              padding: 0 !important;
              font-size: 0.65rem;
              font-weight: 600;
            ">
            {{ 'Wellenlänge' | mrTranslate }}
          </label>

          <!-- Das native Select-Feld wird mit einer festen Breite fixiert -->
          <select
            clrSelect
            name="options"
            [(ngModel)]="selectedOption"
            (change)="onWavelengthChange($event)"
            style="
              color: white !important;
              background-color: transparent !important;
              height: 1.2rem !important;
              min-width: 110px !important;
              margin: 0 !important;
            ">
            <option value="1">10-30</option>
            <option value="2">30-100</option>
            <option value="3">100-300</option>
            <option value="4">300-1000</option>
          </select>
        </clr-select-container>

        <a href="javascript://" class="nav-link nav-icon">
          <cds-icon shape="times" (click)="close()" />
        </a>
      </div>
    </header>
    @for (gr of graph.data; track gr; let ind = $index) {
      @if (gr.yData && gr.yData.length > 0) {
        <div class="card" [dndDraggable]="gr" [dndEffectAllowed]="'move'" [dndDisableIf]="!draganddropactive">
          <div class="card-header" [ngClass]="{ 'cursor-grab': draganddropactive }">
            <div class="clr-row">
              <div class="clr-col-6">
                <cds-icon
                  shape="angle"
                  size="25"
                  (click)="gr.show = !gr.show"
                  [direction]="gr.show ? 'up' : 'down'"
                  style="cursor: pointer; margin-left: -15px; margin-right: 8px"></cds-icon>
                {{ gr.name | mrTranslate }}
              </div>
              <div class="clr-col-6" style="text-align: right">
                <clr-signpost>
                  <cds-icon shape="cog" solid="true" clrSignpostTrigger></cds-icon>
                  <clr-signpost-content [clrPosition]="'left-bottom'" *clrIfOpen>
                    <form clrForm>
                      <clr-input-container style="margin-top: 0px">
                        <label>{{ 'Y-Max' | mrTranslate }}</label>
                        <input clrInput placeholder="Y-Max" name="ymax" [(ngModel)]="gr.layout.yaxis.range[1]" />
                      </clr-input-container>
                      <clr-input-container>
                        <label>{{ 'Y-Min' | mrTranslate }}</label>
                        <input clrInput placeholder="Y-Min" name="ymin" [(ngModel)]="gr.layout.yaxis.range[0]" />
                      </clr-input-container>
                      <button class="btn btn-primary btn-sm" style="margin-top: 1.2rem" (click)="applyYaxis(gr.key)">
                        {{ 'übernehmen' | mrTranslate }}
                      </button>
                    </form>
                  </clr-signpost-content>
                </clr-signpost>
              </div>
            </div>
          </div>
          @if (gr.show) {
            <div class="card-block">
              <div style="width: 100%">
                <div class="clr-col-12">
                  <div>
                    <app-plotly-plot-lokal
                      #plotCmp
                      [id]="gr.key"
                      [className]=""
                      [data]="gr.yData"
                      [layout]="gr.layout ? gr.layout : graph.layout"
                      [config]="graph.config"></app-plotly-plot-lokal>
                  </div>
                </div>
              </div>
            </div>
          }
        </div>
      }
    }
  </div>
</div>
